import {AuthGuard} from '../../../shared/services';
import {PartenairesListComponent} from './partenaires-list.component';
import {PartenairesListResolver} from './partenaires-list.resolver';
import {Route} from '@angular/router';

export const PartenairesListRoutes: Route[] = [
  {
    path: 'list',
    component: PartenairesListComponent,
    canActivate: [AuthGuard],
    resolve: {
      partners: PartenairesListResolver
    }
  }
];
